import { jsx as _jsx } from "react/jsx-runtime";
import { Container, Tray } from './styles';
export const HiddenHorizontalScrollbar = ({ children, ...rest }) => {
    return (_jsx(Container, { ...rest, children: _jsx(Tray, { children: children }) }));
};
//# sourceMappingURL=index.js.map